
(function () {
        // guard
        if (window.cdpPrintableVisibilityInit) return;
        window.cdpPrintableVisibilityInit = true;
      
        const wrapperId = 'cart-drawer-printable-signup';
        const wrapper = document.getElementById(wrapperId);
       
        if (!wrapper) {
          // nothing to do if markup not present on initial load
          // but still set up observer in case it's injected later
        } else {
          // Hide initially until we verify cart
          wrapper.style.display = 'none';
        }
      
    // utility: test if an item is free
        function itemIsFree(item) {
          // shopify ajax cart returns prices in subunits (cents), so 0 means free
          // check a few possible fields (price, final_price, line_price, final_line_price)
          const p = Number(item.price ?? item.final_price ?? 0);
          const lp = Number(item.line_price ?? item.final_line_price ?? item.original_line_price ?? 0);
          // price is per-item, line price is price * quantity (both 0 indicates free)
          return p === 0 || lp === 0;
        }
      
    // debounce helper to avoid multiple rapid visibility updates
    function scheduleUpdate(delay = 150) {
      if (scheduleUpdate._t) clearTimeout(scheduleUpdate._t);
      scheduleUpdate._t = setTimeout(() => {
        updatePrintableVisibility();
      }, delay);
    }

    // fetch cart and update visibility — only show signup when there are free items AND no paid items
    async function updatePrintableVisibility() {
      try {
        const resp = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!resp.ok) {
          console.warn('cdpPrintable: /cart.js fetch failed', resp.status);
          return;
        }
        const cart = await resp.json();
        const items = cart.items || [];
    
        // compute whether cart contains free items and whether it contains paid items
        const hasFree = items.some(itemIsFree);
        const hasPaid = items.some(item => !itemIsFree(item));
    
        const el = document.getElementById(wrapperId);
        if (!el) return; // nothing to toggle
    
        // show the printable signup ONLY when there are free items AND there are NO paid items
        const shouldShow = hasFree && !hasPaid;
        const desired = shouldShow ? '' : 'none';
        if (el.style.display !== desired) {
          el.style.display = desired;
        }
      } catch (err) {
        console.error('cdpPrintable: updatePrintableVisibility error', err);
      }
    }
    
      
        // run on initial load (if wrapper present)
        updatePrintableVisibility();
      
    // handle common theme custom events (many themes emit these)
    ['cart:updated', 'cart:change', 'cart:refresh', 'cart:render'].forEach(evt =>
      document.addEventListener(evt, () => {
        // small delay in case cart data updates asynchronously
        scheduleUpdate(200);
      })
    );
      
    // listen for add-to-cart clicks to re-check (covers many themes)
    // tries several common selectors: data-add-to-cart, .add-to-cart, button[name="add"]
    document.addEventListener('click', (e) => {
      const addBtn = e.target.closest('[data-add-to-cart], .add-to-cart, button[name="add"], input[name="add"]');
      if (!addBtn) return;
      // check shortly after the click to allow Ajax add to complete
      scheduleUpdate(400);
    }, { passive: true });
      
    // observe DOM mutations in case cart drawer is rendered/updated without events
    const observer = new MutationObserver(() => {
      // if wrapper appears for the first time, run check without forcing hide
      const el = document.getElementById(wrapperId);
      if (el) {
        scheduleUpdate(0);
      }
    });
      
        observer.observe(document.body, { childList: true, subtree: true });
      
        // expose for debugging if needed
        window.cdpPrintable = {
          updateVisibility: updatePrintableVisibility,
          isProcessing: false // Flag to prevent cart drawer interference
        };
      
      })();
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      /* cart-drawer-printable: robust event-delegation based JS
         - works when cart drawer content is injected later
         - avoids setInterval polling
         - single click/input handlers (no duplicate listeners)
      */
      
      (function () {
        if (window.cdpPrintableInit) return; // guard for double-includes
        window.cdpPrintableInit = true;
      
        console.log('cdpPrintable: initialized');
      
        // small reusable helpers
        const qs = (sel, root = document) => root.querySelector(sel);
        const qsa = (sel, root = document) => Array.from((root || document).querySelectorAll(sel));
        const isVisible = (el) => !!el && el.offsetParent !== null;
      
        function validateEmail(email) {
          return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
        }
      
        function showError(el) {
          if (!el) return;
          el.classList.remove('hidden');
          el.style.display = 'block';
        }
        function hideError(el) {
          if (!el) return;
          el.classList.add('hidden');
          el.style.display = 'none';
        }
      
        // Update UI for processing state on the "div button"
      // REPLACE the old setProcessing(...) function with this block
      function setProcessing(btnEl, processing) {
        if (!btnEl) return;
        const wrapper = document.getElementById('cart-drawer-printable-signup');
        const nameInput = document.getElementById('cart-drawer-printable-name');
        const emailInput = document.getElementById('cart-drawer-printable-email');
      
        // create spinner inside button (once)
        if (!btnEl._cdpSpinner) {
          const span = document.createElement('span');
          span.className = 'cdp-spinner';
          span.style.display = 'none';
          span.setAttribute('aria-hidden', 'true');
          span.innerHTML = '<svg width="16" height="16" viewBox="0 0 50 50" aria-hidden="true"><circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-dasharray="31.4 31.4" transform="rotate(-90 25 25)"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/></circle></svg>';
          span.style.marginRight = '8px';
          btnEl.insertBefore(span, btnEl.firstChild);
          btnEl._cdpSpinner = span;
        }
      
        if (processing) {
          btnEl.setAttribute('aria-disabled', 'true');
          btnEl.dataset.cdpProcessing = '1';
          btnEl.dataset.cdpPrevText = btnEl.textContent;
          btnEl._cdpSpinner.style.display = '';
          btnEl.textContent = 'Processing...';
          btnEl.insertBefore(btnEl._cdpSpinner, btnEl.firstChild);
          btnEl.classList.add('cdp-processing');
          btnEl.style.pointerEvents = 'none';
          btnEl.style.opacity = '0.8';
      
          // disable inputs
          if (nameInput) { nameInput.setAttribute('disabled', 'disabled'); nameInput.setAttribute('aria-disabled','true'); }
          if (emailInput) { emailInput.setAttribute('disabled', 'disabled'); emailInput.setAttribute('aria-disabled','true'); }
      
          // mark wrapper busy
          if (wrapper) wrapper.setAttribute('aria-busy', 'true');
      
        } else {
          btnEl.removeAttribute('aria-disabled');
          delete btnEl.dataset.cdpProcessing;
          if (btnEl.dataset.cdpPrevText) btnEl.textContent = btnEl.dataset.cdpPrevText;
          if (btnEl._cdpSpinner) btnEl._cdpSpinner.style.display = 'none';
          btnEl.classList.remove('cdp-processing');
          btnEl.style.pointerEvents = '';
          btnEl.style.opacity = '';
      
          // enable inputs
          if (nameInput) { nameInput.removeAttribute('disabled'); nameInput.removeAttribute('aria-disabled'); }
          if (emailInput) { emailInput.removeAttribute('disabled'); emailInput.removeAttribute('aria-disabled'); }
      
          if (wrapper) wrapper.removeAttribute('aria-busy');
        }
      }
      
      
      // Render a friendly "download started" UI inside the printable wrapper
    function showDownloadStartedUI(product = {}) {
      const wrapper = document.getElementById('cart-drawer-printable-signup');
      if (!wrapper) return;
    
      // build safe values
      const title = product.title ? escapeHtml(product.title) : 'Your printable';
      const pdfUrl = product.pdf_url || '';
      
      // Check if this is multiple files
      const isMultiple = title.includes('printable files');
      const downloadText = isMultiple ? 'downloads are starting' : 'download is starting';
      const prepareText = isMultiple ? 'We\'re preparing your files' : `We're preparing <strong>${title}</strong>`;
      const fileText = isMultiple ? 'files will download shortly' : 'file will download shortly';
    
      wrapper.innerHTML = `
        <!-- NEW NOTICE LINE -->
        <div class="cdp-ds-email-notice" role="status" aria-live="polite">
          Also, we have sent you an email with the download ${isMultiple ? 'links' : 'link'} so you can access ${isMultiple ? 'them' : 'it'} whenever you want.
        </div>
    
        <div class="cdp-download-started" role="status" aria-live="polite">
          <div class="cdp-ds-icon" aria-hidden="true">
            <!-- simple check icon -->
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.5" opacity="0.12"/>
              <path d="M7 12.5l2.5 2.5L17 8.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
    
          <h3 class="cdp-ds-title">Your ${downloadText}</h3>
          <p class="cdp-ds-sub">${prepareText}. The ${fileText}</p>
    
          <div class="cdp-ds-actions">
            ${pdfUrl ? `<a class="cdp-ds-fallback" href="${pdfUrl}" target="_blank" rel="noopener noreferrer">If your download doesn't start, click here.</a>` : ''}
            <button type="button" class="cdp-ds-close" aria-label="Close">Close</button>
          </div>
        </div>
      `;
    
      // close button behavior
      const closeBtn = wrapper.querySelector('.cdp-ds-close');
      if (closeBtn) closeBtn.addEventListener('click', () => {
        wrapper.style.display = '';
        wrapper.innerHTML = '';
      });
    }
      
      
      // small HTML escape helper for product.title
      function escapeHtml(s) {
        return String(s || '').replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      }
      
      
      
        // Single delegated input listener for live validation hide
        document.addEventListener('input', (e) => {
          const target = e.target;
          if (!target) return;
      
          if (target.id === 'cart-drawer-printable-name') {
            const nameError = document.getElementById('cart-drawer-printable-name-error');
            if (target.value.trim()) hideError(nameError);
          }
      
          if (target.id === 'cart-drawer-printable-email') {
            const emailError = document.getElementById('cart-drawer-printable-email-error');
            if (validateEmail(target.value.trim())) hideError(emailError);
          }
        }, { passive: true });
      
        // Single delegated click listener (works for dynamically inserted "div" button)
        document.addEventListener('click', async (e) => {
          const btn = e.target.closest('#cart-drawer-printable-button');
          if (!btn) return; // ignore other clicks
      
          // find wrapper and elements at the time of click (may be injected later)
          const wrapper = document.getElementById('cart-drawer-printable-signup');
          const nameInput = document.getElementById('cart-drawer-printable-name');
          const emailInput = document.getElementById('cart-drawer-printable-email');
          const nameError = document.getElementById('cart-drawer-printable-name-error');
          const emailError = document.getElementById('cart-drawer-printable-email-error');
          const createAccountCheckbox = document.getElementById('cart-drawer-printable-create-account');
      
          // safety: if critical elements don't exist, do nothing (maybe cart isn't rendered)
          if (!nameInput || !emailInput || !nameError || !emailError) {
            console.warn('cdpPrintable: one or more elements are not present yet.');
            return;
          }
      
          // Prevent double clicks while processing
          if (btn.dataset.cdpProcessing === '1') {
            console.log('cdpPrintable: already processing, ignoring click');
            return;
          }
      
          // Validation
          let hasError = false;
      
          if (!nameInput.value || !nameInput.value.trim()) {
            showError(nameError);
            hasError = true;
          } else {
            hideError(nameError);
          }
      
          if (!validateEmail(emailInput.value.trim())) {
            showError(emailError);
            hasError = true;
          } else {
            hideError(emailError);
          }
      
          if (hasError) return;
      
          // If user wants to create account -> redirect to login
          if (createAccountCheckbox && createAccountCheckbox.checked) {
            // include return_to so after login they can be redirected back (optional)
            const returnTo = window.location.pathname + window.location.search;
            const loginUrl = '/account/login?return_url=' + encodeURIComponent(returnTo);
            window.location.href = loginUrl;
            return;
          }
      
          // Helper function to remove free items from cart
          async function removeFreeItemsFromCart(freeItems) {
            console.log('cdpPrintable: removing free items from cart', freeItems);
            
            for (const item of freeItems) {
              try {
                // Use Shopify's cart API to remove items
                const removePayload = {
                  updates: {
                    [item.variant_id]: 0  // Set quantity to 0 to remove
                  }
                };
                
                const response = await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(removePayload)
                });
                
                if (response.ok) {
                  console.log(`cdpPrintable: removed item ${item.variant_id} from cart`);
                } else {
                  console.warn(`cdpPrintable: failed to remove item ${item.variant_id}:`, response.status);
                }
              } catch (err) {
                console.warn(`cdpPrintable: error removing item ${item.variant_id}:`, err);
              }
            }
            
            // Trigger cart update events that themes listen to
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:change'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            
            // Force cart UI refresh with more direct methods
            await forceCartRefresh();
          }
          
          // Force cart refresh using the most effective methods
          async function forceCartRefresh() {
            console.log('cdpPrintable: forcing cart refresh');
            
            // Method 1: AJAX reload of cart drawer content
            try {
              // Find cart drawer elements
              const cartDrawerSelectors = [
                'cart-drawer',
                '#cart-drawer', 
                '.cart-drawer',
                '[data-cart-drawer]',
                '.drawer--cart',
                '#CartDrawer'
              ];
              
              let cartDrawerElement = null;
              for (const selector of cartDrawerSelectors) {
                cartDrawerElement = document.querySelector(selector);
                if (cartDrawerElement) {
                  console.log(`cdpPrintable: found cart drawer with selector: ${selector}`);
                  break;
                }
              }
              
              if (cartDrawerElement) {
                // Method 1a: Try section rendering first
                try {
                  const sectionId = cartDrawerElement.id || 'cart-drawer';
                  const response = await fetch(`${window.location.origin}/?section_id=${sectionId}`);
                  if (response.ok) {
                    const html = await response.text();
                    if (html.trim()) {
                      cartDrawerElement.outerHTML = html;
                      console.log(`cdpPrintable: replaced cart drawer via section rendering`);
                      return; // Success, exit early
                    }
                  }
                } catch (err) {
                  console.warn('cdpPrintable: section rendering failed', err);
                }
                
                // Method 1b: Rebuild cart content using cart.js data
                try {
                  const cartResponse = await fetch('/cart.js');
                  if (cartResponse.ok) {
                    const cartData = await cartResponse.json();
                    console.log(`cdpPrintable: rebuilding cart with ${cartData.items.length} items`);
                    
                    // Don't replace entire cart drawer, just refresh it by triggering theme events
                    // This is safer than replacing HTML which might break theme functionality
                    
                    // Dispatch comprehensive update events with cart data
                    const updateEvents = [
                      'cart:updated',
                      'cart:changed', 
                      'cart:refresh',
                      'theme:cart:change',
                      'shopify:cart:updated'
                    ];
                    
                    updateEvents.forEach(eventName => {
                      document.dispatchEvent(new CustomEvent(eventName, {
                        bubbles: true,
                        detail: { cart: cartData, items: cartData.items }
                      }));
                      window.dispatchEvent(new CustomEvent(eventName, {
                        bubbles: true,
                        detail: { cart: cartData, items: cartData.items }
                      }));
                    });
                    
                    console.log(`cdpPrintable: dispatched cart update events with ${cartData.items.length} items`);
                    return; // Success, exit early
                  }
                } catch (err) {
                  console.warn('cdpPrintable: cart data rebuild failed', err);
                }
              }
              
              // Method 1c: Force reload cart items container
              const cartItemsSelectors = [
                '.cart-items',
                '.cart__items', 
                '[data-cart-items]',
                '.drawer__contents',
                '.cart-drawer__contents'
              ];
              
              for (const selector of cartItemsSelectors) {
                const itemsContainer = document.querySelector(selector);
                if (itemsContainer) {
                  try {
                    // Fetch fresh cart data
                    const cartResponse = await fetch('/cart.js');
                    if (cartResponse.ok) {
                      const cartData = await cartResponse.json();
                      console.log(`cdpPrintable: got updated cart data with ${cartData.items.length} items`);
                      
                      // If cart is empty, clear the items container
                      if (cartData.items.length === 0) {
                        itemsContainer.innerHTML = '<p class="cart-empty-message">Your cart is empty</p>';
                        console.log(`cdpPrintable: cleared empty cart items container`);
                      } else {
                        // Try to rebuild items (this is theme-specific, so may not work)
                        console.log(`cdpPrintable: cart still has ${cartData.items.length} items`);
                      }
                    }
                  } catch (err) {
                    console.warn('cdpPrintable: cart items update failed', err);
                  }
                  break;
                }
              }
              
            } catch (err) {
              console.warn('cdpPrintable: AJAX cart refresh failed', err);
            }
            
            // Method 2: Update cart count directly
            try {
              const cartResponse = await fetch('/cart.js');
              if (cartResponse.ok) {
                const cartData = await cartResponse.json();
                const newCount = cartData.item_count || 0;
                
                // Update all possible cart count elements
                const countElements = document.querySelectorAll(
                  '.cart-count, .cart-counter, [data-cart-count], .header-cart-count, .cart-icon-count, .cart-item-count, .cart-count-bubble, [data-cart-render="item_count"]'
                );
                
                countElements.forEach(el => {
                  el.textContent = newCount;
                  el.setAttribute('data-cart-count', newCount);
                  if (newCount === 0) {
                    el.style.display = 'none';
                  } else {
                    el.style.display = '';
                  }
                });
                
                console.log(`cdpPrintable: updated cart count to ${newCount}`);
              }
            } catch (err) {
              console.warn('cdpPrintable: cart count update failed', err);
            }
            
            // Method 3: Try Dawn theme specific refresh
            try {
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                if (typeof cartDrawer.getSectionsToRender === 'function') {
                  cartDrawer.getSectionsToRender().forEach((section) => {
                    document.getElementById(section.id).innerHTML = section.html;
                  });
                }
                if (typeof cartDrawer.renderContents === 'function') {
                  cartDrawer.renderContents(await fetch('/cart.js').then(r => r.json()));
                }
              }
            } catch (err) {
              console.warn('cdpPrintable: Dawn theme refresh failed', err);
            }
            
            // Method 4: Trigger cart change simulation (forces most themes to refresh)
            try {
              // Simulate a mini cart update by triggering quantity change
              const quantityInputs = document.querySelectorAll('[name="updates[]"], .cart-item__quantity input, [data-quantity-input]');
              if (quantityInputs.length > 0) {
                // Trigger change event on first quantity input to force cart refresh
                const event = new Event('change', { bubbles: true });
                quantityInputs[0].dispatchEvent(event);
                console.log('cdpPrintable: triggered quantity change simulation');
              }
              
              // Also try triggering on cart form
              const cartForm = document.querySelector('form[action="/cart"], form[action*="cart"]');
              if (cartForm) {
                const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
                cartForm.dispatchEvent(submitEvent);
                console.log('cdpPrintable: triggered cart form event');
              }
            } catch (err) {
              console.warn('cdpPrintable: cart simulation failed', err);
            }
            
            // Method 5: Dispatch window events (some themes listen to these)
            try {
              const cartData = await fetch('/cart.js').then(r => r.json()).catch(() => null);
              window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData }}));
              
              // Additional events that themes might listen to
              document.dispatchEvent(new CustomEvent('cart:items-changed'));
              document.dispatchEvent(new CustomEvent('theme:cart:change'));
              document.dispatchEvent(new CustomEvent('ajaxCart:updated', { detail: cartData }));
              
              console.log('cdpPrintable: dispatched cart update events');
            } catch (err) {
              console.warn('cdpPrintable: event dispatch failed', err);
            }
            
            // Method 6: Force theme to re-render cart by simulating theme-specific actions
            try {
              // Try to find and trigger theme's cart refresh button/method
              const refreshTriggers = [
                () => {
                  // Look for cart refresh/reload buttons
                  const refreshBtns = document.querySelectorAll('[data-cart-refresh], [data-reload-cart], .cart-refresh');
                  refreshBtns.forEach(btn => btn.click());
                  return refreshBtns.length > 0;
                },
                () => {
                  // Try to trigger cart drawer to re-fetch its content
                  const cartDrawer = document.querySelector('cart-drawer, #CartDrawer');
                  if (cartDrawer && cartDrawer.open) {
                    // Close and reopen to force refresh
                    cartDrawer.open = false;
                    setTimeout(() => { cartDrawer.open = true; }, 100);
                    return true;
                  }
                  return false;
                },
                () => {
                  // Trigger a fake quantity update to force refresh
                  const qtyInputs = document.querySelectorAll('input[name="updates[]"]');
                  if (qtyInputs.length > 0) {
                    const originalValue = qtyInputs[0].value;
                    qtyInputs[0].value = originalValue;
                    qtyInputs[0].dispatchEvent(new Event('change', { bubbles: true }));
                    qtyInputs[0].dispatchEvent(new Event('input', { bubbles: true }));
                    return true;
                  }
                  return false;
                }
              ];
              
              refreshTriggers.forEach((trigger, index) => {
                try {
                  if (trigger()) {
                    console.log(`cdpPrintable: executed refresh trigger ${index + 1}`);
                  }
                } catch (err) {
                  console.warn(`cdpPrintable: refresh trigger ${index + 1} failed`, err);
                }
              });
              
            } catch (err) {
              console.warn('cdpPrintable: theme refresh triggers failed', err);
            }
            
            // Method 7: Call global cart refresh functions if they exist
            const globalRefreshMethods = [
              'refreshCart',
              'updateCart', 
              'reloadCart',
              'cartRefresh'
            ];
            
            globalRefreshMethods.forEach(methodName => {
              if (typeof window[methodName] === 'function') {
                try {
                  window[methodName]();
                  console.log(`cdpPrintable: called global ${methodName}()`);
                } catch (err) {
                  console.warn(`cdpPrintable: global ${methodName}() failed`, err);
                }
              }
            });
            
            console.log('cdpPrintable: cart refresh completed');
          }
          
          // Helper function to close cart drawer
          function closeCartDrawer() {
            console.log('cdpPrintable: attempting to close cart drawer');
            
            // Try multiple common methods to close cart drawer
            const closeMethods = [
              // Method 1: Common cart drawer close buttons
              () => {
                const closeButtons = document.querySelectorAll('[data-cart-drawer-close], .cart-drawer-close, .drawer-close, [aria-label*="Close cart"], [aria-label*="close cart"]');
                for (const btn of closeButtons) {
                  if (btn.offsetParent !== null) { // is visible
                    btn.click();
                    return true;
                  }
                }
                return false;
              },
              
              // Method 2: Dawn theme specific
              () => {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && typeof cartDrawer.close === 'function') {
                  cartDrawer.close();
                  return true;
                }
                return false;
              },
              
              // Method 3: Common drawer overlay click
              () => {
                const overlay = document.querySelector('.drawer-overlay, .cart-drawer-overlay, .overlay');
                if (overlay && overlay.offsetParent !== null) {
                  overlay.click();
                  return true;
                }
                return false;
              },
              
              // Method 4: Escape key simulation
              () => {
                document.dispatchEvent(new KeyboardEvent('keydown', {
                  key: 'Escape',
                  keyCode: 27,
                  bubbles: true
                }));
                return true;
              },
              
              // Method 5: Common theme events
              () => {
                document.dispatchEvent(new CustomEvent('cart:close'));
                document.dispatchEvent(new CustomEvent('drawer:close'));
                return true;
              }
            ];
            
            // Try each method
            for (let i = 0; i < closeMethods.length; i++) {
              try {
                if (closeMethods[i]()) {
                  console.log(`cdpPrintable: cart closed using method ${i + 1}`);
                  return;
                }
              } catch (err) {
                console.warn(`cdpPrintable: close method ${i + 1} failed:`, err);
              }
            }
            
            console.log('cdpPrintable: could not close cart drawer automatically');
          }
    
          // ====== PLACE TO HOOK YOUR GRAPHQL / API CALL ======
          // Example: set processing UI, then call backend, then unset processing
          try {
            setProcessing(btn, true);
            window.cdpPrintable.isProcessing = true;
              await new Promise(resolve => requestAnimationFrame(resolve));
      



      
      // --- find all free product ids (required) ---
    let productIds = [];
    let freeItems = []; // Move this declaration outside the try block
    try {
      const cartResp = await fetch("/cart.js", { credentials: "same-origin" });
      if (!cartResp.ok) {
        console.warn("cdpPrintable: /cart.js returned", cartResp.status);
        // fail fast so backend doesn't get undefined productIds
        alert("Unable to check cart. Please try again.");
        return;
      }
    
      const cart = await cartResp.json();
      console.log("cdpPrintable: cart items", cart.items);
    
      // find all items with price or line_price === 0
      freeItems = (cart.items || []).filter(it => {
        const price = Number(it.price ?? it.final_price ?? 0);
        const line = Number(it.line_price ?? it.final_line_price ?? it.original_line_price ?? 0);
        return price === 0 || line === 0;
      });
    
      if (!freeItems.length) {
        // no free products in cart — block submit and show friendly message
        console.warn("cdpPrintable: no free items found in cart");
        alert("There are no free printables in your cart. Add free items and try again.");
        return;
      }
    
      // collect all product IDs from free items
      productIds = freeItems.map(item => {
        return item.product_id ?? item.variant_id ?? null;
      }).filter(id => id !== null); // remove any null values
    
      console.log("cdpPrintable: found freeItems", freeItems, "-> productIds:", productIds);
    
      if (!productIds.length) {
        // unexpected shape: log and stop
        console.error("cdpPrintable: no valid productIds found in freeItems", freeItems);
        alert("Unable to determine products. Please try again.");
        return;
      }
    
    } catch (e) {
      console.error("cdpPrintable: failed to fetch cart for product_ids", e);
      alert("Network error checking cart — please try again.");
      return;
    }
    
    // Make separate API calls for each product ID (backend only accepts single product_id)
    const results = [];
    const errors = [];
    
    for (let i = 0; i < productIds.length; i++) {
      const productId = productIds[i];
      console.log(`cdpPrintable: processing product ${i + 1}/${productIds.length}: ${productId}`);
      
      try {
        // build payload for single product (backend requirement)
        const payload = {
          name: nameInput.value.trim(),
          email: emailInput.value.trim(),
          product_id: productId // Single product_id as backend expects
        };
        console.log(`cdpPrintable: payload for product ${productId}:`, payload);
    
        const resp = await fetch("https://shop.7daysofplay.com/apps/proxy?shop=hd0eim-tg.myshopify.com&action=storecustomeranddownload", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });
    
        if (!resp.ok) {
          throw new Error(`Server responded ${resp.status} for product ${productId}`);
        }
    
        const result = await resp.json();
        console.log(`cdpPrintable: server result for product ${productId}:`, result);
        
        if (result && result.product && result.product.pdf_url) {
          results.push(result.product);
        } else {
          console.warn(`cdpPrintable: no valid product data in response for product ${productId}`, result);
          errors.push(`Product ${productId}: Invalid response format`);
        }
        
        // Small delay between API calls to avoid overwhelming the server
        if (i < productIds.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 200));
        }
        
      } catch (err) {
        console.error(`cdpPrintable: API call failed for product ${productId}:`, err);
        errors.push(`Product ${productId}: ${err.message}`);
      }
    }
    
    console.log(`cdpPrintable: API calls completed. ${results.length} successful, ${errors.length} failed`);
    
    if (results.length === 0) {
      console.error("cdpPrintable: no successful API responses", { errors });
      alert(`Failed to process any products. ${errors.length > 0 ? 'Errors: ' + errors.join('; ') : 'Please try again.'}`);
      return;
    }
    
    if (errors.length > 0) {
      console.warn("cdpPrintable: some API calls failed", { errors });
      // Continue with successful results, but inform user
    }
      
    // Use the results from multiple API calls
    const productsToDownload = results.filter(p => p && p.pdf_url);
    
    if (productsToDownload.length === 0) {
      console.error("cdpPrintable: no products with pdf_url found in results", results);
      alert("No downloadable files found. Please try again.");
      return;
    }
    
    console.log("cdpPrintable: products to download", productsToDownload);
    
    // Show user feedback if some products failed but others succeeded
    if (errors.length > 0 && productsToDownload.length > 0) {
      console.warn(`cdpPrintable: ${errors.length} product(s) failed, but continuing with ${productsToDownload.length} successful product(s)`);
    }
    
    // Show the "download started" UI first (use first product for display, or create summary)
    const displayProduct = productsToDownload.length === 1 
      ? productsToDownload[0]
      : { title: `${productsToDownload.length} printable files`, pdf_url: '' };
    showDownloadStartedUI(displayProduct);
    
    // ensure UI paints before doing heavy work
    await new Promise(resolve => requestAnimationFrame(resolve));
    
    // try to derive a friendly filename: prefer product.title, fallback to file name from URL
    function getFilenameFromResult(prod, url, index = 0) {
      let baseName = 'download';
      
      if (prod && prod.title) {
        // sanitize title to ascii-ish filename
        baseName = String(prod.title).replace(/[^a-z0-9_\-\. ]/gi, '').trim() || 'download';
      } else {
        try {
          const u = new URL(url);
          const path = u.pathname.split('/').pop() || 'download.pdf';
          baseName = decodeURIComponent(path.split('?')[0]).replace('.pdf', '');
        } catch (e) {
          baseName = 'download';
        }
      }
      
      // If multiple files, add index to filename
      if (productsToDownload.length > 1) {
        baseName += `_${index + 1}`;
      }
      
      return baseName + '.pdf';
    }
    
    // Download all products
    let downloadedCount = 0;
    let failedCount = 0;
    
    for (let i = 0; i < productsToDownload.length; i++) {
      const product = productsToDownload[i];
      const pdfUrl = product.pdf_url;
      const filename = getFilenameFromResult(product, pdfUrl, i);
      
      console.log(`cdpPrintable: downloading ${i + 1}/${productsToDownload.length}: ${filename}`);
      
      // Attempt fetch -> blob download (this will NOT redirect the page)
      let downloaded = false;
      try {
        const fetchResp = await fetch(pdfUrl, { mode: 'cors' });
        if (!fetchResp.ok) throw new Error('PDF fetch failed: ' + fetchResp.status);
        const blob = await fetchResp.blob();
    
        // create object URL and click anchor to download
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        // Append to document so click works reliably on all browsers
        document.body.appendChild(a);
        a.click();
        a.remove();
        // revoke after short delay
        setTimeout(() => { try { URL.revokeObjectURL(blobUrl); } catch (e) {} }, 10000);
        downloaded = true;
        downloadedCount++;
        
        // Small delay between downloads to avoid overwhelming the browser
        if (i < productsToDownload.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 500));
        }
      } catch (err) {
        console.warn(`cdpPrintable: download ${i + 1} via fetch failed (CORS or network). Falling back to open-in-new-tab.`, err);
        downloaded = false;
      }
    
      if (!downloaded) {
        // Fallback: open the PDF in a new tab. Note: this may be popup-blocked if not triggered by a user gesture.
        try {
          window.open(pdfUrl, '_blank', 'noopener');
          downloadedCount++; // Count as successful even though it opened in new tab
        } catch (e) {
          console.warn(`cdpPrintable: fallback window.open failed for download ${i + 1}`, e);
          failedCount++;
          
          // For the last item, if all else fails, navigate same tab
          if (i === productsToDownload.length - 1 && downloadedCount === 0) {
            window.location.href = pdfUrl;
          }
        }
      }
    }
    
    console.log(`cdpPrintable: download summary - ${downloadedCount} successful, ${failedCount} failed`);
    
    // Comprehensive user feedback including API failures and download failures
    const totalApiFailures = errors.length;
    const totalDownloadFailures = failedCount;
    const totalSuccessful = downloadedCount;
    
    if (totalSuccessful === 0) {
      // Complete failure
      let message = "Failed to download any files.";
      if (totalApiFailures > 0) {
        message += ` ${totalApiFailures} product(s) failed to process.`;
      }
      if (totalDownloadFailures > 0) {
        message += ` ${totalDownloadFailures} download(s) failed.`;
      }
      message += " Please try again.";
      alert(message);
    } else if (totalApiFailures > 0 || totalDownloadFailures > 0) {
      // Partial success
      let message = `Successfully downloaded ${totalSuccessful} file(s).`;
      if (totalApiFailures > 0) {
        message += ` ${totalApiFailures} product(s) failed to process from server.`;
      }
      if (totalDownloadFailures > 0) {
        message += ` ${totalDownloadFailures} file(s) failed to download.`;
      }
      alert(message);
    }
    
    // If we had any successful downloads, remove free items from cart and refresh page
    if (totalSuccessful > 0) {
      console.log('cdpPrintable: cleaning up cart after successful downloads');
      
      try {
        // Remove free items from cart
        await removeFreeItemsFromCart(freeItems);
        
        // Show a brief message then reload the page to show updated cart
        setTimeout(() => {
          console.log('cdpPrintable: reloading page to show updated cart');
          window.location.reload();
        }, 2500); // 2.5 second delay to let user see success message
        
      } catch (cartErr) {
        console.warn('cdpPrintable: cart cleanup failed', cartErr);
        // Don't show error to user since downloads were successful
      }
    }
      
      
      
          } catch (err) {
            console.error("cdpPrintable: submission error", err);
            alert("Something went wrong. Please try again.");
          } finally {
            setProcessing(btn, false);
            window.cdpPrintable.isProcessing = false;
          }
        });
      
        // Optionally: observe body for the wrapper being added (only to run any init-once code).
        // Not required for delegation, but included if you want to perform actions once wrapper appears.
        const observer = new MutationObserver((mutations) => {
          if (document.getElementById('cart-drawer-printable-signup')) {
            // If you need to initialize something once when wrapper is added, do it here.
            // e.g. move focus, prefill name/email from a global object, etc.
            // This block runs once wrapper is present; we can then disconnect if desired.
            observer.disconnect();
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      
      })();
      
      
      
      
      
      
      
      